import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { TDocumentDefinitions, Content } from 'pdfmake/interfaces';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { ComplaintsService } from './complaints.service';
import Swal from 'sweetalert2';
import { MainService } from '../../portal/service/main.service'
// import { layouts } from 'chart.js';
 

// (pdfMake as any).vfs = (pdfFonts as any).vfs;



@Injectable({
  providedIn: 'root'
})
export class PdfGeneratorService {

  constructor(private mainService: MainService, private http: HttpClient, private cs: ComplaintsService) { }

  async getcomplaints(b_acct_id: any, com_id: any) {
    let resp = await this.cs.getComplaints(JSON.stringify({ b_acct_id, com_id }));
    return resp;
  }

  extractEnglishDepartments(deptStr: string): string {
    try {
      const parsedArray = JSON.parse(deptStr);
      const englishNames = parsedArray.map((item: any) => {
        const key = Object.keys(item)[0];
        const fullText = item[key];
        return fullText.replace(/\s*\([^)]*\)/g, '').trim();
      });
      return englishNames.join(', ');
    } catch (err) {
      console.error('Failed to parse dept:', err);
      return '-';
    }
  }
  async generateComplaintPDF(b_acct_id: string, com_id: any): Promise<void> {
    try {
      const resp: any = await this.getcomplaints(b_acct_id, com_id);

      if (resp.error || !resp.data || resp.data.length < 1) {
        Swal.fire('Oops !!', `Unable to process your request. Please try again later.`, 'info');
        return;
      }

      const data = resp.data[0];
      const timestamp = data.create_timestamp || data.created_time;

      const formattedTime = new Date(timestamp).toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      const dd: any = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        pageMargins: [40, 60, 40, 60],
        // header: {
        //   stack: [
        //     { image: 'logo', width: 60, margin: [0, 0, 0, 40] },
        //     { text: 'Municipal Corporation, Lucknow', alignment: 'center', style: 'header' },
        //     { text: 'Sampurna Samadhan Diwas', alignment: 'center', style: 'subheader', margin: [0, 5, 0, 15] },
        //   ]
        // },


        footer: function (currentPage: any, pageCount: any) {
          return {
            columns: [
              { text: '', alignment: 'left', margin: [40, 0] },
              { text: `${currentPage} of ${pageCount}`, alignment: 'center', bold: true },
              { text: '', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 9 }
            ],
            margin: [40, 20]
          };
        },
        header: function (currentPage: any, pageCount: any) {
          var arr = []
          arr.push({ image: 'logo', width: 60, alignment: 'center'})
          return arr;
        },


        content: [


          {
            columns: [
              { text: `Municipal Corporation, Lucknow`, fontSize: 20, alignment: 'center', bold: true },

            ],
            margin: [0, 0, 0, 5]
          },
          {
            columns: [
              { text: `Sampurna Samadhan Diwas`, fontSize: 18, alignment: 'center', bold: true },

            ],
            margin: [0, 0, 0, 5]
          },
          { text: " " },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 510, y2: 0, lineWidth: 0.2 }] },
          { text: " " },
          {
            columns: [
              { text: `Ticket Number: ${data.ticket_id}`, style: 'head' },
              { text: `Date: ${data.create_date}`, alignment: 'right', bold: true },

            ],
            // margin: [0, 0, 0, 5]
          },
          {
            text: `Time: ${formattedTime}`,
            alignment: 'right',
            bold: true,
            margin: [0, 0, 11, 10]
          },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },


          {
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  { text: 'Full Name:', style: 'head' },
                  { text: data.full_name || '-', style: 'content' },
                  { text: 'Mobile Number:', style: 'head' },
                  { text: data.mobile_no || '-', style: 'content' },

                ],
                [
                  { text: '', style: 'head', colSpan: 3 }, {}, {}, {}


                ],
                [
                  { text: 'Complaint Department:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: this.extractEnglishDepartments(data.dept), style: 'content', margin: [0, 10, 0, 0], colSpan: 3 },
                  {}, {}
                ],
                [
                  { text: 'Complaint Description:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.complaint_desc || '-', style: 'content', margin: [0, 10, 0, 0], colSpan: 3 },
                  {},
                  {}
                ],
                [
                  { text: 'Zone:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.zone || '-', style: 'content', margin: [0, 10, 0, 0] },
                  { text: 'Ward:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.ward || '-', style: 'content', margin: [0, 10, 0, 0] }
                ],
                [
                  { text: 'Mohalla:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.mohalla || '-', style: 'content', margin: [0, 10, 0, 0] ,colSpan: 3},{},{}],
                 [ { text: 'Uploaded Document:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.com_doc || 'N/A', style: 'content', margin: [0, 10, 0, 0] },{},{}
                ],
                [
                  { text: 'Other Document:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.others_doc || 'N/A', style: 'content', margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] }
                ],
                [
                  { text: 'Instant Resolution Details:', style: 'sub_head', colSpan: 2, margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] },
                  { text: '', style: 'content', margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] }
                ],
                [
                  { text: 'Is Instant Resolved:', style: 'head', margin: [0, 10, 0, 0] },
                  { text: data.is_instant_resolved ? "Yes" : "NO", style: 'content', margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] },
                  { text: " ", margin: [0, 10, 0, 0] }
                ]



              ]
            },
            layout: 'noBorders'
          }

        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true
          },
          subheader: {
            fontSize: 13,
            italics: true
          },
          head: {
            fontSize: 13,
            bold: true


          },
          sub_head: {
            fontSize: 18,
            bold: true


          },
          content: {
            fontSize: 12,
            color:'black'

          },
        },
        images: {
          logo: this.mainService.accountLogoUrl
        }
      };

      if (data.is_instant_resolved) {
        dd.content[11]['table']['body'].push([
          { text: 'Remark:', style: 'head', margin: [0, 10, 0, 0] },
          { text: data.resolved_remark, style: 'content', margin: [0, 10, 0, 0], colSpan: 3 },
          {},
          {}
        ], [
          { text: 'Approval Description:', style: 'head', margin: [0, 10, 0, 0] },
          { text: data.approval_desc, style: 'content', margin: [0, 10, 0, 0], colSpan: 3 },
          {},
          {}
        ], [
          { text: 'Uploaded Document:', style: 'head', margin: [0, 10, 0, 0] },
          { text: data.resolved_doc, style: 'content', margin: [0, 10, 0, 0], colSpan: 3 },
          {},
          {}
        ]
        )

      }


      pdfMake.createPdf(dd).open();
    } catch (error) {
      console.error('PDF generation failed:', error);
      Swal.fire('Error', 'Something went wrong while generating PDF.', 'error');
    }
  }

}
